module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10075.84714a49.jpg";